import HomeIcon from '@material-ui/icons/Home';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import SearchIcon from '@material-ui/icons/Search';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import BackupIcon from '@material-ui/icons/Backup';
import ScheduleIcon from '@material-ui/icons/Schedule';
import PersonIcon from '@material-ui/icons/Person';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SettingsIcon from '@material-ui/icons/Settings';
import AmendmentLayout from 'components/Application/Amendment';
import MeetingAttendance from 'components/Review/MeetingAttendance';

import Landing from 'components/Landing';
import ApplicationLayout from 'components/Application/AllLayout';
import Profile from 'components/Profile';
import Search from 'components/Search';
import UserApproval from 'components/UserApproval';
import ReviewArrangement from 'components/Review/ArrangeMeeting';
import HOAdminEmailDomain from 'views/system/HOAdmin/email/domain';
import HOAdminUserAccount from 'views/system/HOAdmin/user/account';
import IRBSecretaryAdminReviewer from 'views/system/IRBSecretaryAdmin/reviewer';
import IRBSecretaryAdminReviewPanel from 'views/system/IRBSecretaryAdmin/reviewPanel';
import EmailTemplate from 'views/system/HOAdmin/email/Template';
import Help from 'components/Help';
import AccountActivation from 'components/Login/accountActivation';
import ResetPassword from 'components/Login/resetPassword';
import EditGlobalVariables from 'views/system/HOAdmin/GlobalVariables';
import EditBroadcastMessage from 'views/system/HOAdmin/BroadcastMessage';
import PostApprovalList from 'components/PostApproval';
import { getStore } from 'store';
import { setGlobal } from 'store/global/reducer';
const Placeholder = () => <div>Pending to implement</div>;

const iconLookup = {
    dashboard: HomeIcon,
    search: SearchIcon,
    home: AccountBoxIcon,
    login: LockOpenIcon,
    profile: AccountCircleIcon,
    application: NoteAddIcon,
    meeting: ScheduleIcon,
    review: ScheduleIcon,
    reviewer: PersonIcon,
    function: CardTravelIcon,
    setting: SettingsIcon,
    help: LiveHelpIcon,
    'post-approval': BackupIcon,
};

export const getPathComponent = (path) => {
    return pathLookup[path];
};

const pathLookup = {
    '/': Landing,
    '/search': Search,
    '/home/profile': Profile,
    '/home/help': Help,
    '/profile': Profile,
    '/applications/draft': ApplicationLayout,
    '/applications/sent': ApplicationLayout,
    '/applications/confirmed': ApplicationLayout,
    '/applications/returned': ApplicationLayout,
    '/applications/returnedFromIRB': ApplicationLayout,
    '/applications/returnedToCCO': ApplicationLayout,
    '/applications/received': ApplicationLayout,
    '/applications/distributed': ApplicationLayout,
    '/applications/for-review': ApplicationLayout,
    '/applications/reviewed': ApplicationLayout,
    '/applications/approved': ApplicationLayout,
    '/applications/completed': ApplicationLayout,
    '/applications/verified': ApplicationLayout,
    '/applications/acknowledged': ApplicationLayout,
    '/applications/expired': ApplicationLayout,
    '/applications/archived': ApplicationLayout,
    '/applications/all': ApplicationLayout,
    '/applications/amendment-detail': AmendmentLayout,
    '/post-approval-document/draft': PostApprovalList,
    '/post-approval-document/sent': PostApprovalList,
    '/post-approval-document/received': PostApprovalList,
    '/post-approval-document/confirmed': PostApprovalList,
    '/post-approval-document/returned': PostApprovalList,
    '/post-approval-document/returnedFromIRB': PostApprovalList,
    '/post-approval-document/returnedToCCO': PostApprovalList,
    '/post-approval-document/for-review': PostApprovalList,
    '/post-approval-document/distributed': PostApprovalList,
    '/post-approval-document/reviewed': PostApprovalList,
    '/post-approval-document/approved': PostApprovalList,
    '/post-approval-document/completed': PostApprovalList,
    '/post-approval-document/verified': PostApprovalList,
    '/post-approval-document/acknowledged': PostApprovalList,
    '/post-approval-document/expired': PostApprovalList,
    '/post-approval-document/archived': PostApprovalList,
    '/post-approval-document/all': PostApprovalList,
    '/meeting-arrangement': Placeholder,
    '/review-arrangement/arrangeMeeting': ReviewArrangement,
    '/review-arrangement/updateMeetingAttendance': MeetingAttendance,
    '/reviewer-maintenance/reviewer': IRBSecretaryAdminReviewer,
    '/reviewer-maintenance/review-panel': IRBSecretaryAdminReviewPanel,
    '/function/report-statistic': Placeholder,
    '/function/user-approval': UserApproval,
    '/HOAdmin-system/email-domain': HOAdminEmailDomain,
    '/HOAdmin-system/user-account': HOAdminUserAccount,
    '/HOAdmin-system/edit-global-variables': EditGlobalVariables,
    '/HOAdmin-system/edit-broadcast-message': EditBroadcastMessage,
    '/HOAdmin-system/email-template': EmailTemplate,
    '/help': Help,
    '/user/account-activation': AccountActivation,
    '/user/reset-password': ResetPassword,
};

export const getIconLookup = (key) => {
    const icon = iconLookup[key];

    if (!icon) {
        return null;
    }

    return icon;
};

export const getMenuAction = (action) => {
    if (action === '/applications/create-new-application') {
        return createApplicationMenuAction;
    }

    return null;
};

const createApplicationMenuAction = () => {
    const { dispatch } = getStore();

    dispatch(
        setGlobal({
            isShowAlertWindow: true,
        }),
    );
};
